// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1ur7n","topBottomGutter":"Layout_topBottomGutter__Oc5jo"};